import { useLocation } from 'react-router'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export const useIsQrCodeAccessPage = (): boolean => {
    const location = useLocation()
    return location.pathname === routes.qrAccess.path
}
